import styled from 'styled-components';

export const SignInFormContainer = styled.div`

    display: flex;
    flex-direction: column;
    width: 380px;

`;

export const ButtonsContainer = styled.div`

    display: flex;
    justify-content: space-between;
`;

    
export const Title = styled.h2`

    margin: 10px 0 ;

`;